import { BffApiClientMolecule } from "@/app/api-client/store"
import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { CollectionMoleculeReatom } from "@/app/collections/store/index.reatom"
import { pickOwnerUnionAddress } from "@/app/nft/search/filters/resolve-owner-filter"
import { WalletConnectMoleculeReatom } from "@/app/wallet-connect/store.reatom"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import {
  getAllUserCollectionItemsQueryParams,
  getUserCollectionItemsCountQueryParams,
} from "./utils"

export const UserCollectionItemsMoleculeReatom = molecule((mol) => {
  const bffApiClient = mol(BffApiClientMolecule)
  const { collectionId } = mol(CollectionMoleculeReatom)
  const { evmUnionAddress, solanaUnionAddress } = mol(
    WalletConnectMoleculeReatom,
  )
  const { blockchainsQueryFilter } = mol(BlockchainFiltersMoleculeReatom)

  const userCollectionItemsCountQueryParams = computed(() => {
    const blockchains = blockchainsQueryFilter()
    const owner = pickOwnerUnionAddress(blockchains, {
      evmUnion: evmUnionAddress(),
      solanaUnion: solanaUnionAddress(),
    })

    const searchQueryParams = getUserCollectionItemsCountQueryParams(
      bffApiClient,
      { collectionId, owner },
      blockchains,
    )

    return {
      ...searchQueryParams,
      refetchInterval: 3000,
      enabled: !!owner,
    }
  }, "userCollectionItemsCountQueryParams")

  const allUserCollectionItemsQueryParams = computed(() => {
    const blockchains = blockchainsQueryFilter()
    const owner = pickOwnerUnionAddress(blockchains, {
      evmUnion: evmUnionAddress(),
      solanaUnion: solanaUnionAddress(),
    })

    const searchQueryParams = getAllUserCollectionItemsQueryParams(
      bffApiClient,
      {
        collectionId,
        owner,
      },
      blockchains,
    )

    return {
      ...searchQueryParams,
      enabled: !!owner,
    }
  }, "allUserCollectionItemsQueryParams")

  return {
    allUserCollectionItemsQueryParams,
    userCollectionItemsCountQueryParams,
  }
})
